const DateTypes = Object.freeze({
  DATE_DOCUMENT_COMPLETED: 'DATE_DOCUMENT_COMPLETED',
  DATE_SIGNED: 'DATE_SIGNED',
})

export default DateTypes
